<template>
  <div class="ev-digital-event-room ev-digital-event-modal-window users-mw">
    <div class="header">
      <button type="button" class="btn btn-primary pull-right close-modal" @click="$emit('close')">
        <i class="fa fa-lg fa-times"></i>
      </button>

      <div class="title"><i aria-hidden="true" class="fa fa-lg fa-user-plus"></i> Invite other people to the call</div>
      <div class="search">
        <div class="search-group">
          <div class="search-box">
            <input type="text" class="form-control" placeholder="Search..." v-model="searchQuery" />
          </div>
          <div class="search-ico"><i aria-hidden="true" class="ar-icon icon-search-light"></i></div>
        </div>
        <div class="filter-az">
          <div class="list-az">
            <button
              :class="[filterItem === activeAlphabetFilter ? 'btn-primary' : 'btn-default']"
              v-for="filterItem in alphabetFilters"
              :key="filterItem"
              class="btn btn-sm"
              @click="activeAlphabetFilter = filterItem"
              :disabled="!getAlphabetUsers(filterItem).length"
            >
              {{ filterItem.toUpperCase() }}
            </button>
          </div>
        </div>
        <div class="filter-box">
          <div class="filter-title"><b>Filter:</b></div>
          <div class="key-node my">
            <label class="styled-cb">
              <span class="filter-name">My {{ groupTerminology }}</span>
              <input id="users-mw-my-table" type="checkbox" v-model="filters.isMyTable" />
              <span class="checkmark"></span>
            </label>
          </div>
          <div class="key-node" :class="{ my: !isSingleRoom }">
            <label class="styled-cb">
              <span class="filter-name">Contacts</span>
              <input id="users-mw-my-network" type="checkbox" v-model="filters.isInContacts" />
              <span class="checkmark"></span>
            </label>
          </div>
          <div class="key-node" v-if="!isSingleRoom">
            <room-filter v-model="filters.byRoom" :disabled="filters.isMyTable"></room-filter>
          </div>
        </div>
      </div>
    </div>
    <div class="body">
      <div class="content-body">
        <ul v-if="users.length" class="guest-list rows">
          <li class="guest" v-for="user in users" :key="'search-users-' + user.userUUID">
            <input
              type="checkbox"
              :value="user.userUUID"
              :disabled="!isUserSelected(user) && !canAddPersonToVideoCall"
              class="user-checkbox"
              style="margin-right: 10px; cursor: pointer"
              v-model="selectedUsers"
            />
            <person :person="user" :options="{ actions: false, inlineActions: false, hidePopover: true }"></person>
          </li>
          <li v-if="showLoadMoreButton" class="usr-load-more">
            <a href="javascript:void(0);" @click="loadMoreUsers"
              ><i class="fa fa-chevron-down" aria-hidden="true"></i><span> load more </span
              ><i class="fa fa-chevron-down" aria-hidden="true"></i
            ></a>
          </li>
        </ul>
        <div v-else class="text-center">
          <p>&nbsp;</p>
          <p>No one is currently available with video chat capability.</p>
          <p>Please change your search or filter or check back in a bit...</p>
        </div>
      </div>
    </div>
    <div class="footer">
      <button
        type="button"
        class="btn btn-primary pull-right"
        :disabled="!canAddPeopleToVideoCall"
        @click="
          createVideoCallInvites(selectedUsers);
          $emit('close');
        "
      >
        Invite {{ selectedUsers.length ? "(" + selectedUsers.length + ")" : "0" }} selected
        {{ selectedUsers.length === 1 ? "person" : "people" }}
      </button>
      <button type="button" class="btn btn-primary pull-right" @click="$emit('close')">Close</button>
      <div v-if="isActionAvailable()" class="pull-right has-error">
        This action is no longer available
      </div>
    </div>
  </div>
</template>

<script>
import UsersSearchMixin from "@/components/DigitalEvent/RoomList/Room/mixins/UsersSearchMixin";
import VideoCallInviteMixin from "@/components/DigitalEvent/RoomList/Room/mixins/Invite/VideoCallInviteMixin";
import Person from "@/components/DigitalEvent/RoomList/Room/People/Person";
import RoomListCheckFilter from "@/components/DigitalEvent/RoomList/Room/components/RoomListCheckFilter.vue";
import { MEDIA_DEVICE_STATUSES } from "@/helpers/constants";
import { mapGetters } from "vuex";

export default {
  name: "UsersMW",
  mixins: [UsersSearchMixin, VideoCallInviteMixin],
  components: {
    person: Person,
    roomFilter: RoomListCheckFilter
  },
  data() {
    return {
      selectedUsers: [],
      roomsBuffer: []
    };
  },
  computed: {
    ...mapGetters({
      activeVideoChat: "videoChat/activeVideoChat",
      activeRoom: "room/activeRoom",
      groupTerminology: "room/groupTerminology",
      currentUser: "users/currentUser",
      isSingleRoom: "room/isSingleRoom"
    }),
    /**
     * List of VideoChat member UUIDs
     * @return {Array}
     */
    videoChatMembersUUIDs() {
      return this.$store.getters["videoChat/videoChatMembersUUIDs"];
    },

    _users() {
      return this.$store.getters["videoChat/usersAvailableForVideoCall"];
    },

    /**
     * List of users that available for VideoCall
     * @return {Array}
     */
    users() {
      return this._pagedResult;
    },

    /**
     * Check that we can add one more person to the call
     * @return {boolean}
     */
    canAddPersonToVideoCall() {
      return this.$store.getters["videoChat/availableNumberOfSeatsForVideoCall"] - this.selectedUsers.length > 0;
    },

    /**
     * Check that user can add peoople to the call
     * @return {boolean}
     */
    canAddPeopleToVideoCall() {
      if (this.activeVideoChat && !this.isVideoCallInitiator) {
        return this.activeVideoChat.allowInvitations && this.selectedUsers.length;
      } else {
        return this.selectedUsers.length;
      }
    },
    /**
     * Check that user is call initiatior
     * @return {boolean}
     */
    isVideoCallInitiator() {
      return this.activeVideoChat?.initiatorUUID === this.$store.state.users.user.user_uuid;
    },
    isMyTable() {
      return this.filters.isMyTable;
    }
  },
  methods: {
    isUserSelected(user) {
      return this.selectedUsers.includes(user.userUUID);
    },
    isUserSelectable(user) {
      return (
        user.isOnline &&
        user.mediaDeviceStatus >= MEDIA_DEVICE_STATUSES.ALLOW &&
        !this.isUserAlreadyOnCall(user.userUUID)
      );
    },

    isUserAlreadyOnCall(userUUID) {
      return this.videoChatMembersUUIDs.indexOf(userUUID) !== -1;
    },

    toggleUser(userUUID) {
      let userIndex = this.selectedUsers.indexOf(userUUID);
      if (userIndex === -1) {
        this.selectedUsers.push(userUUID);
      } else {
        this.selectedUsers.splice(userIndex, 1);
      }
    },

    isActionAvailable() {
      return (
        this.activeVideoChat &&
        this.activeVideoChat.initiatorUUID !== this.currentUser.userUUID &&
        !this.activeVideoChat.allowInvitations
      );
    }
  },
  watch: {
    isMyTable: function(val) {
      if (val) {
        this.roomsBuffer = [...this.filters.byRoom];
        this.filters.byRoom = [this.activeRoom.uuid];
      } else {
        this.filters.byRoom = [...this.roomsBuffer];
      }
    }
  }
};
</script>
